export default "__VITE_ASSET__BoDQ$I9m__"